import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    userLastName: state.customCreateAccountForm.fieldValues.userLastName,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const FirstNameWidget: React.FC<Props> = ({ userLastName, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Last Name");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, userLastName, "userLastName", () =>
        validateFieldBy(isRequired, label, userLastName, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "userLastName", value: event.target.value });
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={userLastName || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(FirstNameWidget);
